<template>
  <div class="main-area">
    <div v-if="$route.meta.rank == 3">
      <el-breadcrumb separator=":">
        <el-breadcrumb-item>当前位置</el-breadcrumb-item>
        <el-breadcrumb-item>维修分析</el-breadcrumb-item>
        <div style="text-align: right"><el-button @click="goBack" style="margin: 0 20px;" :size="GLOBAL.config.systemSize">返回</el-button></div>

      </el-breadcrumb>
      <el-row class="margin-top-10">
        <el-col :span="2" class="margin-top-10">
          <label class="search-label">
            区域:
          </label>
        </el-col>
        <el-col :span="4" class="margin-top-10">
          <cascader :set-props="setProps"
                    :set-size="GLOBAL.config.systemSize" maxlength="64"
                    ref="myArea">
          </cascader>
        </el-col>
        <el-col :span="2"  style="text-align: right" class="margin-top-10">
          <label class="search-label">
            起止时间:
          </label>
        </el-col>
        <el-col :span="10" class="margin-top-10" style="text-align: left">
          <div class="block">
			  <div style="display: inline-block;">
            <el-date-picker
              :size="GLOBAL.config.systemSize"
              v-model="searchForm.timeTwo.beginTime"
              type="datetime"
              value-format="yyyyMMddHHmmss"
              :picker-options="pickerOptions"
              placeholder="选择开始日期时间">
            </el-date-picker>
			</div>
			<div style="display: inline-block;">
            <el-date-picker
              :size="GLOBAL.config.systemSize"
              v-model="searchForm.timeTwo.endTime"
              type="datetime"
              value-format="yyyyMMddHHmmss"
              :picker-options="pickerOptions"
              placeholder="选择结束日期时间">
            </el-date-picker>
			</div>
          </div>
        </el-col>

        <el-col :span="2" class="margin-top-10">
          <el-button type="primary" @click="doSearch" :size="GLOBAL.config.systemSize" style="margin-left: 30px;" icon="el-icon-search">查询
          </el-button>
        </el-col>
        <el-col :span="2" class="margin-top-10">
          <el-button
            type="primary"
            @click="output"
            :size="GLOBAL.config.systemSize"
            icon="el-icon-upload2"
          >导出
          </el-button>
        </el-col>
      </el-row>
      <el-divider content-position="left">图表信息</el-divider>
      <el-row style="margin-top: 10px">
        <el-col :span="18" >
          <barCharts  ref="barChart" @changeBarDate="changeBarDate"></barCharts>
        </el-col>
        <el-col :span="6" >
          <el-table style="width: 100%"
										height="500"
                    :data="tableData"
                    element-loading-text="数据处理中...请稍等..."
                    @cell-click="changeIndex"
                    v-loading="loading">
            <!--序号-->
            <el-table-column type="index" label="序号" width="80px" align="center"/>
            <!--车牌号-->
            <el-table-column prop="name" label="名称" align="center"/>
            <!--数量-->
            <el-table-column prop="pumpNum" label="数量" align="center"/>
          </el-table>
        </el-col>
      </el-row>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
<!--      <router-view></router-view>-->
  </div>
</template>

<script>
  import cascader from '../../../components/Cascader'
  import barCharts from './BarCharts'
    export default {
        name: 'analyzeP',
      data () {
        return {
          ssqhdm: JSON.parse(localStorage.getItem('gcUserInfo')).ssqhdm,
          userInfo: localStorage.getItem('gcUserInfo')?JSON.parse(localStorage.getItem('gcUserInfo')):{},
          values: '',
          loading: false,
          setProps: {
            multiple: false, // 单选
            checkStrictly: true, // 父节点取消选中关联
            value: 'code',
            label: 'name',
            children: 'children',
            leaf: 'leaf'
          },
          searchForm: {timeTwo: {beginTime: '', endTime: '', type: '1'}},
          tableData: [
          ],
          // 层级
          index: '0',
          // 乡镇code
          arr1: [],
          // 村code
          arr2: [],
          code: '',
          // 分页参数
          // pagination: {
          //   pageSizeList: [10, 20, 30, 40, 50],
          //   pageSize: 10,
          //   layout: 'total, sizes, prev, pager, next, jumper',
          //   total: 0,
          //   currentPage: 1
          // },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now()
                }
            }

        }
      },
      created () {
      },
      mounted () {
        this.show()
      },
      watch: {
        tableData () {
          this.$refs.barChart.showInit(this.tableData)
        },
        $route (to, from) {
          let _this = this
          if (to.path === '/dataAnalysis/Maintenance') {
            setTimeout(function () {
              _this.$refs.barChart.showInit(_this.tableData)
              _this.$refs.myArea.init(_this.code)
            }, 100)
          }
        }
      },
      computed: {},
      methods: {
          output: function(){
              let _this=this
              let code = _this.$refs.myArea.sendToParent('value')
              if (!code) {
                  code = this.ssqhdm
              }
              let flagNew = '1'
              if ((code && code == this.ssqhdm) || !code) {
                  flagNew = '1'
              } else {
                  flagNew = '2'
              }
              let info = {}
              let path = '/ReportForm'
              console.log(code.substring(code.length-2, code.length))
              if (code.substring(code.length-2, code.length) != '00') {
                  info = {
                      current: 1,
                      size: 10000,
                      records: [
                          {
                              cmCode: code,
                              beginTime: _this.searchForm.timeTwo.beginTime,
                              endTime: _this.searchForm.timeTwo.endTime
                          }
                      ]
                  }
                  path = '/wxReportFormsq'
              } else {
                  info = {
                      timeTwo: {
                          code :code?code:'',
                          beginTime: _this.searchForm.timeTwo.beginTime,
                          endTime: _this.searchForm.timeTwo.endTime,
                          type: '1',
                          flagNew: flagNew
                      }
                  }
                  path = '/ccReportForm'
              }
              // let  path='/ccReportForm'
              let name ="维修分析报表.xlsx"
              this.FUNCTIONS.systemFunction.postDownFileurl(this, {
                  info: info,
                  userInfo:{
                      user:JSON.parse(localStorage.getItem('gcUserInfo'))
                  }
              },this.CONFIG.urls.root + this.CONFIG.urls.business.downLoad +path,name)

          },
          // 初始化
        show(){
          const code = JSON.parse(localStorage.getItem('gcUserInfo')).ssqhdm
          this.code = code
          const num = this.showMeth1(code)
          if(num === 0){
            this.init()
          } else {
            this.biaogeChange(code)
          }
          this.$refs.myArea.init(code)
        },
        // 判断当前code是哪一级
        showMeth1(code){
          if(code%1000000 === 0){
            this.index = '0'
            return 0
          }
          if(code%100 === 0){
            this.index = '1'
            return 1
          }
          this.index = '2'
          return 2
        },
        init () {
          let _this = this
          _this.loading = true
          // this.showMeth1(this.code)
          let searchParams = this.searchForm
          searchParams.baseService = 'TGcBxxxServiceImpl'
          // 3、 调接口获取数据
          _this.FUNCTIONS.systemFunction.interactiveData(
            _this,
            _this.GLOBAL.config.businessFlag.zxUser, // 业务模块参数未传
            _this.GLOBAL.config.handleType.getVillages, // 业务模块类型
            searchParams, //
            null,
            resultData => {
              setTimeout(function () {
                _this.loading = false
              }, 200)
              if (resultData) {
                if (resultData.code === '200') {
                  _this.tableData = resultData.obj
                  this.index = '1'
                }
                console.log(this.tableData)
              } else {
                _this.$message.warning('获取列表数据失败～')
              }
            },
            () => {
              _this.loading = false
            }
          )
        },
        // 表格跳转
        biaogeChange (code) {
			// debugger
          let aa = this.showMeth1(code)
		  // alert(this.index)
           // debugger
          let _this = this
          if (this.index === '1') {
            let info = {code: code, type: '1', baseService: 'TGcBxxxServiceImpl',beginTime: _this.searchForm.timeTwo.beginTime,endTime: _this.searchForm.timeTwo.endTime}
            _this.FUNCTIONS.systemFunction.interactiveData(
              _this,
              _this.GLOBAL.config.businessFlag.zxUser, // 业务模块参数未传
              _this.GLOBAL.config.handleType.getVillagesCommittee, // 业务模块类型
              info, //
              null,
              resultData => {
                _this.loading = false
                if (resultData) {
                  if (resultData.code === '200') {
                    _this.tableData = resultData.obj
                    // _this.index = '2'
                  }
                } else {
                  _this.$message.warning('获取列表数据失败～')
                }
              },
              () => {
                _this.loading = false
              }
            )
          } else {
            this.$router.push({
              name: 'analyzeTabl',
              params: {
                code: code,
                beginTime:_this.searchForm.timeTwo.beginTime,
                endTime: _this.searchForm.timeTwo.endTime
              }
            })
          }
        },
        // 子向父传参, 触发图形调用的方法 data = 图形X的名称
        changeBarDate (data) {
          if (data === '平均值' || data === '最大值' || data === '最小值') {
            return
          }
          let _this = this
          let code = this.getCodeByName(data)

          _this.biaogeChange(code)
        },
        // 根据name获取code
        getCodeByName (data) {
          let code = ''
          for (const e in this.tableData) {
            if (this.tableData[e].name === data) {
              code = this.tableData[e].code
              return code
            }
          }
        },
        changeIndex (data) {
          if (this.index === '0') {
              this.init()
          } else {
            this.biaogeChange(data.code)
          }
        },
        // 查询
        doSearch () {
          let _this = this
            if (this.searchForm.timeTwo.beginTime && this.searchForm.timeTwo.endTime) {
                if (!_this.FUNCTIONS.systemFunction.compareDate(this.searchForm.timeTwo.beginTime, this.searchForm.timeTwo.endTime)) {
                    this.$message.warning('开始日期不能大于结束日期！')
                    return
                }
            }
          let code = _this.$refs.myArea.sendToParent('value')
          if (!code || code === this.userInfo.ssqhdm) {
              this.show()
          } else {
              const num = _this.showMeth1(code)
              if (num === 2) {
                  this.biaogeChange(code)
              } else {
                  this.code = code
                  let info = {code: code, type: '1', beginTime: _this.searchForm.timeTwo.beginTime, endTime: _this.searchForm.timeTwo.endTime, baseService: 'TGcBxxxServiceImpl'}
                  _this.FUNCTIONS.systemFunction.interactiveData(
                      _this,
                      _this.GLOBAL.config.businessFlag.zxUser, // 业务模块参数未传
                      _this.GLOBAL.config.handleType.getVillagesGather, // 业务模块类型
                      info, //
                      null,
                      resultData => {
                          _this.loading = false
                          console.log(JSON.stringify(resultData.obj))
                          if (resultData) {
                              if (resultData.code === '200') {
                                  _this.tableData = resultData.obj.slice(1)
                                  let num = _this.showMeth1(code)
                                  if(num === 0){
                                      _this.index = 0
                                  }
                                  if(num === 1){
                                      _this.index = 2
                                  }
                              }
                          } else {
                              _this.$message.warning('获取列表数据失败～')
                          }
                      },
                      () => {
                          _this.loading = false
                      }
                  )
              }
          }
        },
        goBack: function () {
          let _this = this
          if (this.index === '0' || this.index === '1') {
            _this.index = '0'
            this.$router.go(-1)
          } else {
            _this.init()
            _this.index = '0'
          }
        }
      },
      components: {
        cascader,
        barCharts
      }
    }
</script>

<style scoped>
.block{
	display: block;
}
</style>



// WEBPACK FOOTER //
// src/view/system/Maintenance/analyzeP.vue